import { AxiosInstance } from 'axios';
import { Result } from 'services/Result';
import { LogService } from 'services/LogService';
import { IPermissions, IPermissionsPayload } from 'interfaces/api/IPermissions';

class PermissionService {
  private axiosInstance: AxiosInstance;

  private logService: LogService;

  constructor(axiosInstance: AxiosInstance, logService: LogService) {
    this.axiosInstance = axiosInstance;
    this.logService = logService;
  }

  getPermissions = async (payload: IPermissionsPayload) => {
    try {
      const response = await this.axiosInstance.post<Result<IPermissions>>(`games/permissions`, payload);
      if (response.data && !response.data.isError && response.data.data) {
        return response.data.data;
      }
      throw Error(JSON.stringify(response));
    } catch (err) {
      this.logService.logError({ error: err, message: `Exception when getting permissions.` });
      throw Error(`Failed to fetch permissions`);
    }
  };
}

export default PermissionService;
